import { j as r } from "./jsx-runtime-3tyXYecC.mjs";
import { useRef as x } from "react";
import { T as g } from "./text-field-ZOMRKQAY.mjs";
import { I as j } from "./icon-v2-DGtVEk7e.mjs";
import { m as S } from "./tss-DN0acMKN.mjs";
import { f as i } from "./index-LyFokDcn.mjs";
import { I as c } from "./InputAdornment-T4xPPRnD.mjs";
import { I as b } from "./icon-button-BxDvkq_l.mjs";
import { I as y } from "./CircleX14x14-Dx82f2vj.mjs";
import { I as F } from "./MagGlass16x16-C5rwnQuW.mjs";
const w = S()((t, { value: e }, a) => ({
  clearAdornment: {
    opacity: e ? 1 : 0,
    backgroundColor: "transparent",
    "&&": {
      backgroundColor: "transparent"
    }
  }
})), z = (t) => {
  const { biId: e, onBlur: a, onChange: l, onClear: m, onFocus: u, onKeyDown: f, placeholder: d = "Search", value: n, variant: p, width: h } = t, s = x(null), { classes: I } = w({ value: n });
  return /* @__PURE__ */ r.jsx(
    g,
    {
      biId: e,
      "data-fabric-component": "SearchFilter",
      InputProps: {
        ariaLabel: window.jQuery ? $.__("Search") : "Search",
        endAdornment: /* @__PURE__ */ r.jsx(c, { className: I.clearAdornment, position: "end", children: /* @__PURE__ */ r.jsx(
          b,
          {
            ariaLabel: window.jQuery ? $.__("Search filter clear button") : "Search filter clear button",
            biId: `${e}-search-filter-clear`,
            floatingIcon: !0,
            hasBounding: !1,
            icon: i.ifFeature("encore", "circle-xmark-solid", /* @__PURE__ */ r.jsx(y, {})),
            onClick: () => {
              var o;
              m(), (o = s.current) == null || o.focus();
            },
            type: "button",
            variant: "outlined"
          }
        ) }),
        startAdornment: /* @__PURE__ */ r.jsx(c, { position: "start", children: i.ifFeature(
          "encore",
          /* @__PURE__ */ r.jsx(j, { name: "magnifying-glass-regular", size: 16 }),
          /* @__PURE__ */ r.jsx(F, { "aria-hidden": !0 })
        ) })
      },
      onBlur: a,
      onChange: (o) => l(o.target.value),
      onFocus: u,
      onKeyDown: f,
      placeholder: d,
      ref: s,
      value: n,
      variant: p,
      width: h
    }
  );
};
export {
  z as S
};
//# sourceMappingURL=search-filter-BbumO_Wr.mjs.map
